import React from 'react';
import { motion } from 'framer-motion';

const springEasing = [0.22, 1, 0.36, 1];

const clients = [
  { name: 'NorTrans AS', initials: 'NT', color: '#004F98', textColor: '#FFFFFF', industry: 'Transport & Logistikk' },
  { name: 'Bergen Buss', initials: 'BB', color: '#FF5722', textColor: '#FFFFFF', industry: 'Kollektivtransport' },
  { name: 'Fjord Frakt', initials: 'FF', color: '#1A3A5C', textColor: '#E0E4E8', industry: 'Godstransport' },
  { name: 'Stavanger Taxi', initials: 'ST', color: '#2D4A22', textColor: '#E0E4E8', industry: 'Persontransport' },
  { name: 'Arktis Logistikk', initials: 'AL', color: '#3D1A5C', textColor: '#E0E4E8', industry: 'Arktisk Logistikk' },
  { name: 'Vestland Kjøring', initials: 'VK', color: '#5C3A1A', textColor: '#E0E4E8', industry: 'Privat Kjøring' },
  { name: 'Oslo Distribusjon', initials: 'OD', color: '#1A4A3A', textColor: '#E0E4E8', industry: 'Distribusjon' },
  { name: 'Trondheim Fleet', initials: 'TF', color: '#4A1A1A', textColor: '#E0E4E8', industry: 'Flåtestyring' },
];

const ClientLogosGrid = () => {
  return (
    <section style={{ padding: '80px 24px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '56px' }}>
        <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#FF5722', display: 'block', marginBottom: '12px' }}>Våre kunder</span>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '36px', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '16px', letterSpacing: '-0.02em' }}>Betrodd av ledende norske selskaper</h2>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', color: 'var(--color-muted-foreground)', maxWidth: '520px', margin: '0 auto', lineHeight: 1.6 }}>Fra små transportselskaper til store logistikkaktører — Veiassistent hjelper alle med å spare penger på norske veier.</p>
      </div>
      {/* Logos grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px', position: 'relative' }}>
        {/* Background geometric accent */}
        <div style={{ position: 'absolute', top: '-20px', right: '-20px', width: '120px', height: '120px', border: '2px solid rgba(255,87,34,0.08)', borderRadius: '2px', transform: 'rotate(15deg)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-20px', left: '-20px', width: '80px', height: '80px', border: '1px solid rgba(0,79,152,0.1)', borderRadius: '2px', transform: 'rotate(-10deg)', pointerEvents: 'none' }} />

        {clients?.map((client, i) => (
          <motion.div
            key={client?.name}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06, duration: 0.45, ease: springEasing }}
            whileHover={{ y: -4, transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] } }}
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(224,228,232,0.08)',
              borderRadius: '2px',
              padding: '24px 20px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '12px',
              cursor: 'default',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {/* Corner geometric accent */}
            <div style={{ position: 'absolute', top: 0, right: 0, width: '24px', height: '24px', borderBottom: `2px solid ${client?.color}`, borderLeft: `2px solid ${client?.color}`, opacity: 0.4 }} />

            {/* Logo */}
            <div style={{
              width: '56px', height: '56px',
              background: client?.color,
              borderRadius: '2px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: `0 4px 16px ${client?.color}33`
            }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '18px', fontWeight: 700, color: client?.textColor }}>{client?.initials}</span>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '4px' }}>{client?.name}</div>
              <div style={{ fontFamily: 'var(--font-caption)', fontSize: '11px', fontWeight: 500, color: 'var(--color-muted-foreground)', letterSpacing: '0.04em' }}>{client?.industry}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ClientLogosGrid;
